import { FormField } from '../types';
import { matchesCondition } from '../conditions';

export const empty = (v: unknown) => v == null || v === '' || (Array.isArray(v) && v.length === 0);

export function clientValidate(field: FormField, value: unknown, values: Record<string, unknown>): string | undefined {
  if (field.visible_when && !matchesCondition(field.visible_when, values)) return;
  const required = field.validations.some((r) => r.type === 'required' && (r.value == null || Boolean(r.value))) || (!!field.required_when && matchesCondition(field.required_when, values));
  if (required && empty(value)) return field.validations.find((r) => r.type === 'required')?.message || `${field.label} is required.`;
  if (empty(value)) return;
  for (const rule of field.validations) {
    if (rule.type === 'required') continue;
    if (rule.type === 'min_length' && String(value).length < Number(rule.value)) return rule.message || `${field.label} is too short.`;
    if (rule.type === 'max_length' && String(value).length > Number(rule.value)) return rule.message || `${field.label} is too long.`;
    if (rule.type === 'min' && Number(value) < Number(rule.value)) return rule.message || `${field.label} is below the minimum.`;
    if (rule.type === 'max' && Number(value) > Number(rule.value)) return rule.message || `${field.label} is above the maximum.`;
    if (rule.type === 'regex') {
      try { if (!new RegExp(String(rule.value)).test(String(value))) return rule.message || `${field.label} has an invalid format.`; }
      catch { return rule.message || `${field.label} has an invalid format.`; }
    }
    if (rule.type === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(value))) return rule.message || `${field.label} must be a valid email.`;
    if ((rule.type === 'number' || rule.type === 'integer') && Number.isNaN(Number(value))) return rule.message || `${field.label} must be a number.`;
    if (rule.type === 'integer' && !Number.isInteger(Number(value))) return rule.message || `${field.label} must be an integer.`;
    if (rule.type === 'one_of') { const allowed = Array.isArray(rule.value) ? rule.value : String(rule.value ?? '').split(',').map((item) => item.trim()); if (!allowed.some((item) => String(item) === String(value))) return rule.message || `${field.label} has an unsupported value.`; }
    if (rule.type === 'file_extension') { const files = Array.isArray(value) ? value : [value]; const allowed = String(rule.value ?? '').split(',').map((item) => item.trim().toLowerCase()).filter(Boolean); if (files.some((file: any) => { const name = String(file?.name ?? file ?? '').toLowerCase(); return !allowed.some((ext) => name.endsWith(ext.startsWith('.') ? ext : `.${ext}`)); })) return rule.message || `${field.label} has an unsupported file type.`; }
    if (rule.type === 'file_size') {
      const files = Array.isArray(value) ? value : [value];
      const maxBytes = Number(rule.value);
      if (files.some((file: any) => file?.size > maxBytes)) return rule.message || `${field.label} contains a file that is too large.`;
    }
  }
}

export function sameFieldDefinitions(a: FormField[], b: FormField[]): boolean {
  try { return JSON.stringify(a) === JSON.stringify(b); } catch { return false; }
}

export function sameValue(a: unknown, b: unknown): boolean {
  if (Object.is(a, b)) return true;
  if (Array.isArray(a) || Array.isArray(b)) { try { return JSON.stringify(a) === JSON.stringify(b); } catch { return false; } }
  return false;
}
